"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGerudoContainer = void 0;
const react_1 = require("react");
const useGetGerudoContainer = () => {
    const ref = (0, react_1.useRef)(null);
    const getGerudoContainer = () => {
        var _a;
        return ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.closest(".gerudo")) || document.getElementById("gerudo") || document.body;
    };
    return {
        ref,
        getGerudoContainer,
    };
};
exports.useGetGerudoContainer = useGetGerudoContainer;
//# sourceMappingURL=useGetGerudoContainer.js.map